import base from '@/functions/base'
import publicModules from '@/store/modules/publicModules'
import { MessageBox } from 'element-ui'
import { i18n } from '@/i18n'
const state = {
  modal: {
    form: ''
  },
  btnStatus: {
    loginNoteBtn: false,
    loginPwdBtn: false,
    forgetPwdBtn: false,
    registerBtn: false,
    wxBindBtn: false
  },
  showCaptcha: {
    codeLogin: false,
    pwdLogin: false,
    forgetPassword: false,
    register: false
  },
  imgCodeData: {
    loginNoteImgCode: '',
    loginNoteImgCodeKey: '',
    loginPwdImgCode: '',
    loginPwdImgCodeKey: '',
    regNoteImgCode: '',
    regNoteImgCodeKey: '',
    pwdNoteImgCode: '',
    pwdNoteImgCodeKey: '',
    wxNoteImgCode: '',
    wxNoteImgCodeKey: ''
  },
  NoteCodeData: {
    loginNoteCodeKey: '',
    regNoteCodeKey: '',
    forgetPwdNoteCodeKey: '',
    wxNoteCodeKey: ''
  },
  QRCodeData: {},
  wxOpenId: ''
}

const mutations = {}

const actions = {
  // 获取图形验证码
  async loginChangeCodeFn (context, payload) {
    base.publicGetRequest('/code/getImgCode', '', response => {
      // console.log(response)
      if (response.success) {
        context.state.imgCodeData[payload] = response.data.data
        context.state.imgCodeData[`${payload}Key`] = response.data.imageCodeKey
      } else {
        publicModules.mutations.showMsg(context, {
          msg: response.message || i18n.t('wangLuoCuoWuQingShaoHouZaiShi'),
          type: 'error'
        })
      }
    }, err => {
      console.log(err)
      publicModules.mutations.showMsg(context, {
        msg: i18n.t('wangLuoCuoWuQingShaoHouZaiShi'),
        type: 'error'
      })
    })
  },
  // 获取验证码
  async getNoteCodeFn (context, payload) {
    return new Promise((resolve, reject) => {
      const origin = payload.origin
      delete payload.origin
      base.publicPostRequest('/code/getSMSCode', payload, response => {
        // console.log(response)
        if (response.code === '200') {
          publicModules.mutations.showMsg(context, { msg: i18n.t('yanZhengMaFaSongChengGong'), type: 'success' })
          resolve(response)
        } else if (response.code === '508') {
          if (window.screen.width > 1200) {
            MessageBox.confirm(i18n.t('HuoQuPinFan'), i18n.t('yanZhengMaHuoQuGuoYuPinFan'), {
              confirmButtonText: i18n.t('woZhiDaoLe'),
              cancelButtonText: i18n.t('lianXiKeFu'),
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
            }).catch(action => {
              if (action === 'cancel') {
                window.open('http://dct.zoosnet.net/LR/Chatpre.aspx?id=DCT48682217&lng=cn', '_blank')
              } else { // 点击X关闭
              }
            })
          } else {
            publicModules.mutations.showMsg(context, { msg: (response.msg || i18n.t('faSongShiBai')), type: 'error' })
          }
          reject(response)
        } else {
          context.state.showCaptcha[origin] = true
          publicModules.mutations.showMsg(context, { msg: (response.msg || i18n.t('faSongShiBai')), type: 'error' })
          reject(response)
        }
      }, response => {
        // console.log(response)
        publicModules.mutations.showMsg(context, { msg: i18n.t('faSongShiBai'), type: 'error' })
        reject(response)
      })
    })
  },
  // 获取邮箱验证码
  async getEmailCodeFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/code/sendMailCode', payload, response => {
        // console.log(response)
        if (response.success) {
          publicModules.mutations.showMsg(context, { msg: i18n.t('faSongChengGong'), type: 'success' })
          resolve(response)
        } else {
          publicModules.mutations.showMsg(context, { msg: (response.msg || i18n.t('faSongShiBai')), type: 'error' })
          reject(response)
        }
      }, response => {
        // console.log(response)
        publicModules.mutations.showMsg(context, { msg: i18n.t('faSongShiBai'), type: 'error' })
        reject(response)
      })
    })
  },
  // 密码登录
  async pwdLoginFn (context, payload) {
    context.state.btnStatus.loginPwdBtn = true
    return new Promise((resolve, reject) => {
      base.publicLoginPostRequest('/login', '', payload, response => {
        // console.log(response)
        if (response.headers.openverification) {
          context.state.showCaptcha.pwdLogin = true
          actions.loginChangeCodeFn(context, 'loginPwdImgCode')
        }
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('dengLuShiBai')),
            type: 'error'
          })
          context.state.btnStatus.loginPwdBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.loginPwdBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('dengLuShiBai'),
          type: 'error'
        })
        reject(response.data)
      })
    })
  },
  // 验证码登录
  async telNoteLoginFn (context, payload) {
    context.state.btnStatus.loginNoteBtn = true
    return new Promise((resolve, reject) => {
      base.publicLoginPostRequest('/mobileLogin', '', payload, response => {
        // console.log(response)
        if (response.headers.openverification) {
          context.state.showCaptcha.codeLogin = true
          actions.loginChangeCodeFn(context, 'loginNoteImgCode')
        }
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('dengLuShiBai')),
            type: 'error'
          })
          context.state.btnStatus.loginNoteBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.loginNoteBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('dengLuShiBai'),
          type: 'error'
        })
        reject(response.data)
      })
    })
  },
  // 注册并登录
  async registerLoginFn (context, payload) {
    context.state.btnStatus.registerBtn = true
    return new Promise((resolve, reject) => {
      base.publicJSONPostRequest('/user/register', payload, response => {
        // console.log(response)
        if (response.headers.openverification) {
          context.state.showCaptcha.register = true
          actions.loginChangeCodeFn(context, 'regNoteImgCode')
        }
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('zhuCeShiBai')),
            type: 'error'
          })
          context.state.btnStatus.registerBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.registerBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('zhuCeShiBai'),
          type: 'error'
        })
        reject(response)
      })
    })
  },
  // 确认重置密码并登录
  async forgetPwdLoginFn (context, payload) {
    context.state.btnStatus.forgetPwdBtn = true
    return new Promise((resolve, reject) => {
      base.publicJSONPostRequest('/user/resetPassword', payload, response => {
        // console.log(response)
        if (response.headers.openverification) {
          context.state.showCaptcha.forgetPassword = true
          actions.loginChangeCodeFn(context, 'pwdNoteImgCode')
        }
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('caoZuoShiBai')),
            type: 'error'
          })
          context.state.btnStatus.forgetPwdBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.forgetPwdBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('caoZuoShiBai'),
          type: 'error'
        })
        reject(response)
      })
    })
  },
  // 使用微信code获取用户openid
  async getWXOpenIdFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/wx/getOpenId', { wxCode: payload }, response => {
        // console.log(response)
        if (response.success) {
          resolve(response)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: i18n.t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [i18n.t('weiXin')]),
            type: 'error'
          })
          reject(response)
        }
      }, response => {
        // console.log(response)
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [i18n.t('weiXin')]),
          type: 'error'
        })
        reject(response)
      })
    })
  },
  // 验证微信号码是否绑定
  async getWXIsBindUserFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/wx/isBind', { openId: payload }, response => {
        // console.log(response)
        if (response.success) {
          resolve(response)
        } else {
          resolve(response)
        }
      }, response => {
        // console.log(response)
        reject(response)
      })
    })
  },
  // 检查密码是否合格
  async getUserCheckPsdFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/user/checkPassword', { password: payload }, response => {
        // console.log(response)
        if (response.success) {
          resolve(response)
        } else {
          resolve(response)
        }
      }, response => {
        // console.log(response)
        reject(response)
      })
    })
  },
  // 查询用户是否注册，验证手机号/邮箱是否绑定微信
  async getUserIsExistFn (context, payload) {
    return new Promise((resolve, reject) => {
      // base.publicGetRequest('/user/doesItExist', { userAccount: payload }, response => {
      base.publicGetRequest('/user/registerOrNot', { userAccount: payload }, response => {
        // console.log(response)
        if (response.success) {
          resolve(response)
        } else {
          resolve(response)
        }
      }, response => {
        // console.log(response)
        reject(response)
      })
    })
  },
  // 验证手机号/邮箱是否绑定微信
  async getUserWXExistFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest(payload.url, { phone: payload.value }, response => {
        // console.log(response)
        if (response.success) {
          resolve(response)
        } else {
          resolve(response)
        }
      }, response => {
        // console.log(response)
        reject(response)
      })
    })
  },
  // 微信登录
  async WXLoginFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicLoginPostRequest('/wxLogin', '', payload, response => {
        // console.log(response)
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('dengLuShiBai')),
            type: 'error'
          })
          context.state.btnStatus.wxBindBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.wxBindBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('dengLuShiBai'),
          type: 'error'
        })
        reject(response.data)
      })
    })
  },
  // 获取微信登录二维码
  async getWXLoginQRCodeFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/wx/getQrCode', payload, response => {
        // console.log(response)
        if (response.success) {
          context.state.QRCodeData = response.data
          resolve(response)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (response.msg || i18n.t('huoQuDengLuErWeiMaShiBai')),
            type: 'error'
          })
          reject(response)
        }
      }, response => {
        // console.log(response)
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('huoQuDengLuErWeiMaShiBai'),
          type: 'error'
        })
        reject(response)
      })
    })
  },
  // 定时执行 在扫码后获取openId
  async getWXLoginOpenIdFn (context, payload) {
    return new Promise((resolve, reject) => {
      base.publicGetRequest('/wx/scanCodeIsSuccessful', { eventKey: context.state.QRCodeData.uuid }, response => {
        // console.log(response)
        if (response.success) {
          context.state.wxOpenId = response.data
          resolve(response)
        } else {
          reject(response)
        }
      }, response => {
        // console.log(response)
        reject(response)
      })
    })
  },
  // 三方平台绑定
  async sfBindFn (context, payload) {
    context.state.btnStatus.wxBindBtn = true
    const { url, params } = payload
    return new Promise((resolve, reject) => {
      base.publicJSONPostRequest(url, params, response => {
        // console.log(response)
        const res = response.data || {}
        if (res.success) {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('bangDingChengGong')),
            type: 'success'
          })
          resolve(res)
        } else {
          context.state.btnStatus.wxBindBtn = false
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('caoZuoShiBai')),
            type: 'error'
          })
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.wxBindBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('caoZuoShiBai'),
          type: 'error'
        })
        reject(response)
      })
    })
  },
  // 三方平台登录
  async sfLoginFn (context, payload) {
    return new Promise((resolve, reject) => {
      const { url, params } = payload
      base.publicLoginPostRequest(url, '', params, response => {
        // console.log(response)
        const res = response.data || {}
        if (res.success) {
          resolve(res)
        } else {
          publicModules.mutations.showMsg(context, {
            msg: (res.msg || i18n.t('dengLuShiBai')),
            type: 'error'
          })
          context.state.btnStatus.wxBindBtn = false
          reject(res)
        }
      }, response => {
        // console.log(response)
        context.state.btnStatus.wxBindBtn = false
        publicModules.mutations.showMsg(context, {
          msg: i18n.t('dengLuShiBai'),
          type: 'error'
        })
        reject(response.data)
      })
    })
  },
}

export default {
  state,
  mutations,
  actions
}
